import { useRef, useState } from "react";
import { toast } from "sonner";
import { UploadSimple, FileText, Eye, X } from "@phosphor-icons/react";
import { api, errMsg } from "@/lib/api";
import { fileUrl } from "@/components/ImageUpload";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function DocUploader({ value = [], onChange, label = "Documentos", testId }) {
  const [tipo, setTipo] = useState("");
  const [loading, setLoading] = useState(false);
  const inputRef = useRef();

  const handle = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setLoading(true);
    const fd = new FormData();
    fd.append("file", f);
    try {
      const { data } = await api.post("/upload", fd);
      const doc = { id: data.path, tipo: tipo || f.name, path: data.path, filename: f.name };
      onChange([...(value || []), doc]);
      setTipo("");
      toast.success("Archivo subido");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const remove = (id) => onChange((value || []).filter((d) => d.id !== id));

  return (
    <div>
      <Label className="text-xs">{label}</Label>
      <div className="mt-1 space-y-2">
        {(value || []).length > 0 && (
          <ul className="space-y-1">
            {value.map((d) => (
              <li key={d.id} className="flex items-center gap-2 text-sm border border-border rounded-sm px-2 py-1.5 bg-secondary/40">
                <FileText size={16} className="text-muted-foreground shrink-0" />
                <span className="flex-1 truncate">{d.tipo || d.filename}</span>
                <a href={fileUrl(d.path)} target="_blank" rel="noreferrer" className="text-primary hover:underline"><Eye size={16} /></a>
                <button type="button" onClick={() => remove(d.id)} className="text-red-600"><X size={16} /></button>
              </li>
            ))}
          </ul>
        )}
        <div className="flex gap-2">
          <Input value={tipo} onChange={(e) => setTipo(e.target.value)} placeholder="Tipo (ej. INE, comprobante)" className="rounded-sm h-9" />
          <input ref={inputRef} type="file" className="hidden" data-testid={testId} onChange={handle} />
          <Button type="button" variant="outline" className="rounded-sm gap-2 shrink-0" disabled={loading} onClick={() => inputRef.current?.click()}>
            <UploadSimple size={16} /> {loading ? "Subiendo…" : "Subir"}
          </Button>
        </div>
      </div>
    </div>
  );
}
